import React from "react";
import { Row, Col } from "antd";
import { Metrics } from "../../theme";
import { OButton, buttonStyle } from "./OButton";
import ColorButton, { ColorSelection, ColorSquare } from "./ColorButton";

export const ButtonGroup = ({ 
	buttonsProps = [],
	Component = OButton,
	rowProps = {},
	colProps = {}
}
)=>{
	return <Row type="flex" justify="end" gutter={Metrics.button.bigSpaceMargin} {...rowProps} >
		{buttonsProps.map((btnElement, index)=>{
			const { children } = btnElement;
			if(children !== undefined){
				return <Col key={index} {...colProps}>
					{children}
				</Col>;
			}else if(btnElement.text){
				return <Col key={index} {...colProps}>
					<Component {...btnElement}>
						{btnElement.text}
					</Component>
				</Col>;
			}
			return <Col key={index} {...colProps}>
				<Component {...btnElement} key={index} />
			</Col>;}
		)}
	</Row>;
};

export const OButtonGroup = (props)=>{
	const extendProps = Object.assign({}, props, {
		rowProps:{
			...props.rowProps,
			height: Metrics.button.wrapperHeight
		},
		spaceSize: Metrics.button.bigSpaceMargin
	});
	extendProps.buttonsProps = Array.from(props.buttonsProps, (v)=>{
		v.style = {...v.style, 
			minWidth: Metrics.button.wrapperButtonWidth,
			height: Metrics.button.wrapperHeight
		};
		return v;
	});

	return ButtonGroup(extendProps);
};
export { OButton, buttonStyle,
	ColorButton, ColorSquare, ColorSelection };


// WEBPACK FOOTER //
// ./src/components/button/index.js